import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, ChevronDown, ArrowRight } from "lucide-react";
import LoginDrawer from "../auth/LoginDrawer";

import { useAuth } from "../../../context/AuthContext";
import { colors as DS, TechLabel } from "../../../design-system";

const ACCENT = DS.product.jobs;

export default function Navbar() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAuth = !!user;
  const role = user?.role || "jobseeker";

  const [searchQuery, setSearchQuery] = useState("");
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/jobs/list?keyword=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <>
      <nav
        className="sticky top-0 z-50 border-b"
        style={{
          background: "rgba(247,247,245,0.92)",
          backdropFilter: "saturate(160%) blur(14px)",
          WebkitBackdropFilter: "saturate(160%) blur(14px)",
          borderColor: DS.hairline,
          fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
        }}
      >
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 gap-4">
            {/* LOGO */}
            <Link to="/jobs" className="flex items-center gap-3 group flex-shrink-0">
              <img
                src="/logo 2.jpg"
                alt="WebIdeal Logo"
                className="w-10 h-10 object-contain bg-white p-1 transform group-hover:scale-105 transition-transform duration-300"
                style={{ border: `1px solid ${DS.hairline}` }}
              />
              <div>
                <span className="text-lg font-extrabold tracking-tight" style={{ color: DS.forest }}>
                  WebIdeal
                </span>
                <TechLabel style={{ color: ACCENT }}>module · jobs</TechLabel>
              </div>
            </Link>

            {/* CENTER SEARCH */}
            <form
              onSubmit={handleSearch}
              className="hidden lg:flex flex-1 max-w-xl"
              style={{ border: `1px solid ${DS.hairline}` }}
            >
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search jobs · role, skill, company"
                className="flex-1 bg-transparent px-4 py-2.5 text-sm focus:outline-none"
                style={{ color: DS.forest, fontFamily: "inherit" }}
              />
              <button
                type="submit"
                className="cursor-pointer px-4 inline-flex items-center gap-1.5 text-xs font-bold uppercase transition-colors duration-150"
                style={{
                  letterSpacing: "0.16em",
                  background: DS.forest,
                  color: DS.paper,
                }}
              >
                <Search className="w-3.5 h-3.5" />
                Search
              </button>
            </form>

            {/* RIGHT */}
            <div className="flex items-center gap-2.5 flex-shrink-0">
              {isAuth ? (
                <Link to={role === "employer" ? "/recruit/dashboard" : "/jobs/dashboard"}>
                  <button
                    type="button"
                    className="ds-skeu-btn-primary cursor-pointer h-10 px-5 text-xs font-bold uppercase inline-flex items-center"
                    style={{ letterSpacing: "0.16em" }}
                  >
                    Go to dashboard
                    <ArrowRight className="w-3.5 h-3.5 ml-2" />
                  </button>
                </Link>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => setIsLoginOpen(true)}
                    className="hidden sm:inline-flex cursor-pointer h-10 px-5 text-xs font-bold uppercase border bg-transparent items-center transition-colors duration-150 hover:bg-[#1A3C2B]/[0.04]"
                    style={{
                      letterSpacing: "0.16em",
                      borderColor: DS.forest,
                      color: DS.forest,
                    }}
                  >
                    Login
                  </button>
                  <Link to="/jobs/auth" className="hidden sm:block">
                    <button
                      type="button"
                      className="ds-skeu-btn-primary cursor-pointer h-10 px-5 text-xs font-bold uppercase inline-flex items-center"
                      style={{ letterSpacing: "0.16em" }}
                    >
                      Register
                    </button>
                  </Link>
                  <Link
                    to="/jobs/auth"
                    className="hidden md:inline-flex items-center gap-1 text-xs font-bold uppercase pl-3 ml-1 border-l transition-colors hover:text-[#1A3C2B]"
                    style={{
                      letterSpacing: "0.16em",
                      borderColor: DS.hairline,
                      color: ACCENT,
                    }}
                  >
                    For employers
                    <ChevronDown className="w-3.5 h-3.5" />
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      <LoginDrawer
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
      />
    </>
  );
}
